module.exports = __webpack_public_path__ + "img/icon-pdf.ed30d047.png";